import React from "react";
import Icons from "./Icons";

const AchievementsSection = ({
  section,
  updateSectionItem,
  removeSectionItem,
  addSectionItem,
}) => {
  const getConfig = () => {
    switch (section.type) {
      case "certifications":
        return {
          nameLabel: "Certification Name",
          namePlaceholder: "e.g., AWS Solutions Architect",
          dateLabel: "Date Obtained",
          datePlaceholder: "e.g., May 2023",
          showDescription: false,
          addButton: "Add Certification",
        };
      case "awards":
        return {
          nameLabel: "Award Name",
          namePlaceholder: "e.g., Employee of the Year",
          dateLabel: "Year",
          datePlaceholder: "e.g., 2023",
          showDescription: true,
          descriptionLabel: "Description",
          descriptionPlaceholder:
            "Brief description of the award and why you received it",
          addButton: "Add Award",
        };
      case "publications":
        return {
          nameLabel: "Publication Title",
          namePlaceholder: "e.g., Machine Learning in Healthcare: A Review",
          dateLabel: "Publisher/Journal",
          datePlaceholder: "e.g., IEEE Journal",
          showYear: true,
          yearLabel: "Year",
          yearPlaceholder: "e.g., 2023",
          showDescription: true,
          descriptionLabel: "Abstract/Description",
          descriptionPlaceholder:
            "Brief description or abstract of the publication",
          addButton: "Add Publication",
        };
      case "achievements":
      default:
        return {
          nameLabel: "Achievement",
          namePlaceholder: "e.g., Increased sales by 40% in Q3 2023",
          showDescription: true,
          descriptionLabel: "Details",
          descriptionPlaceholder:
            "Provide context and impact of this achievement",
          addButton: "Add Achievement",
          hideDate: true,
        };
    }
  };

  const config = getConfig();

  const getEmptyItem = () => {
    const base = {
      name: section.type === "publications" ? "" : undefined,
      title:
        section.type === "publications"
          ? ""
          : section.type === "achievements"
          ? ""
          : undefined,
    };

    if (!config.hideDate) {
      if (section.type === "certifications") base.period = "";
      else if (section.type === "awards") base.year = "";
      else if (section.type === "publications") base.publisher = "";
    }

    if (config.showYear) base.year = "";
    if (config.showDescription) base.description = "";

    return base;
  };

  return (
    <div className="achievements-section">
      {section.items?.map((item) => (
        <div key={item.id || item} className="achievement-item">
          <button
            onClick={() => removeSectionItem(item.id)}
            className="item-remove-button"
            title="Remove item"
          >
            <Icons.X className="w-4 h-4" />
          </button>

          <div className="item-content">
            <div className="form-group">
              <label className="form-label">{config.nameLabel}</label>
              <input
                type="text"
                value={item.name || item.title || item}
                onChange={(e) =>
                  updateSectionItem(item.id, {
                    [section.type === "publications" ||
                    section.type === "achievements"
                      ? "title"
                      : "name"]: e.target.value,
                  })
                }
                placeholder={config.namePlaceholder}
                className="form-input"
              />
            </div>

            {!config.hideDate && (
              <div className="form-row">
                <div className="form-group flex-1">
                  <label className="form-label">{config.dateLabel}</label>
                  <input
                    type="text"
                    value={item.period || item.year || item.publisher || ""}
                    onChange={(e) =>
                      updateSectionItem(item.id, {
                        [section.type === "certifications"
                          ? "period"
                          : section.type === "awards"
                          ? "year"
                          : "publisher"]: e.target.value,
                      })
                    }
                    placeholder={config.datePlaceholder}
                    className="form-input"
                  />
                </div>

                {config.showYear && (
                  <div className="form-group" style={{ width: "120px" }}>
                    <label className="form-label">{config.yearLabel}</label>
                    <input
                      type="text"
                      value={item.year || ""}
                      onChange={(e) =>
                        updateSectionItem(item.id, { year: e.target.value })
                      }
                      placeholder={config.yearPlaceholder}
                      className="form-input"
                    />
                  </div>
                )}
              </div>
            )}

            {config.showDescription && (
              <div className="form-group">
                <label className="form-label">
                  {config.descriptionLabel}
                  {config.descriptionLabel && (
                    <span className="label-hint">Optional</span>
                  )}
                </label>
                <textarea
                  value={item.description || ""}
                  onChange={(e) =>
                    updateSectionItem(item.id, { description: e.target.value })
                  }
                  placeholder={config.descriptionPlaceholder}
                  className="form-textarea"
                  rows={2}
                />
              </div>
            )}
          </div>
        </div>
      ))}

      <button
        onClick={() => addSectionItem(getEmptyItem())}
        className="add-item-button"
      >
        <Icons.Plus className="w-4 h-4" />
        {config.addButton}
      </button>

      {section.items?.length === 0 && (
        <p className="empty-message">
          No {section.type} added yet. Add your {section.type} to showcase your
          accomplishments.
        </p>
      )}
    </div>
  );
};

export default AchievementsSection;
